import { Disc3, Tag, Calendar } from "lucide-react";
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from "@/components/ui/responsive-dialog";
import { TrackPreviewList } from "@/components/TrackPreviewList";
import type { AlbumItem } from "./types";

export function AlbumDetailDrawer({
  album,
  open,
  onOpenChange,
}: {
  album: AlbumItem | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent
        className="max-w-2xl"
        desktopClassName="p-0 overflow-hidden"
        mobileClassName="max-h-[92dvh]"
      >
        {album && (
          <div className="flex max-h-[92dvh] flex-col overflow-hidden">
            <div className="grid gap-5 p-5 sm:grid-cols-[160px_1fr] sm:p-6">
              <div className="mx-auto aspect-square w-40 overflow-hidden rounded-xl bg-muted ring-1 ring-border sm:mx-0 sm:w-full">
                {album.cover_url ? (
                  <img loading="lazy" decoding="async"
                    src={album.cover_url}
                    alt={`${album.title} — ${album.artist}`}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="grid h-full w-full place-items-center text-muted-foreground">
                    <Disc3 className="h-10 w-10" />
                  </div>
                )}
              </div>
              <div className="min-w-0">
                <ResponsiveDialogHeader>
                  <ResponsiveDialogTitle className="text-xl">
                    {album.title}
                  </ResponsiveDialogTitle>
                </ResponsiveDialogHeader>
                <div className="mt-1 truncate text-sm text-muted-foreground">
                  {album.artist}
                </div>
                <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
                  {album.year && (
                    <span className="inline-flex items-center gap-1 rounded-full border border-border bg-surface/60 px-2.5 py-1 text-muted-foreground">
                      <Calendar className="h-3 w-3" /> {album.year}
                    </span>
                  )}
                  {album.price_brl != null && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-foreground px-2.5 py-1 text-background">
                      <Tag className="h-3 w-3" /> R$ {album.price_brl}
                    </span>
                  )}
                  {album.genres?.slice(0, 4).map((g) => (
                    <span
                      key={g}
                      className="rounded-full border border-border px-2.5 py-1 text-muted-foreground"
                    >
                      {g}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="overflow-y-auto px-5 pb-6 sm:px-6">
              <TrackPreviewList artist={album.artist} title={album.title} />
            </div>
          </div>
        )}
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}
